<template>
  <div>
    <project-card :projectData="projectData" @back="backProjectList"></project-card>
    <Tabs value="inviteArticles">
      <TabPane :label="isSurveyProject?'调研公告挂网':'招标公告挂网'" name="inviteArticles">
        <inviteArticles :projectData="projectData" :articles="surveyArticles" @refreshArticles="getArtilces" v-if="isSurveyProject"></inviteArticles>
        <inviteArticles :projectData="projectData" :articles="inviteArticles" @refreshArticles="getArtilces" v-else></inviteArticles>
      </TabPane>
      <TabPane label="更正公告挂网" name="correctArticles">
        <correctArticles :projectData="projectData" :articles="correctArticles" @refreshArticles="getArtilces"></correctArticles>
      </TabPane>
      <!-- <TabPane label="中标公告挂网" name="biddingArticles">
        <biddingArticles :projectData="projectData" :articles="biddingArticles" @refreshArticles="getArtilces"></biddingArticles>
      </TabPane> -->
      <span slot="extra">
        <Button type="primary" size="small" style="margin-top:8px;margin-right:10px;" @click="expertFill">专家确认表填写</Button>
        <Button type="primary" size="small" style="margin-top:8px;margin-right:10px;" @click="expertShow">专家确认表</Button>
      </span>
    </Tabs>
    <!-- 专家表 -->
    <Modal class="expert-modal" v-model="expertFileVisible" title="专家抽取确认" :mask-closable="false" width="1000">
      <iframe :src="expertFileUrl" style="width:100%;height:600px;"></iframe>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>


<script>
import inviteArticles from './inviteArticles'
import correctArticles from './correctArticles'
import biddingArticles from './biddingArticles'
import projectCard from '../projectCard'
import requestUrls from '@/lib/requestUrls'
import ajax from '@/lib/ajax'

export default {
  name: 'articles',
  props: {
    projectData: {
      type: Object
    }
  },
  data() {
    return {
      inviteArticles: [],
      correctArticles: [],
      biddingArticles: [],
      expertFileUrl: '',
      expertFileVisible: false
    }
  },
  computed: {
    isSurveyProject () {
      return this.projectData.businessType === '采购咨询' && this.projectData.projectProperty === '市场调研'
    }
  },
  components: {
    inviteArticles,
    correctArticles,
    biddingArticles,
    projectCard
  },
  methods: {
    async getArtilces() {
      let rep = await ajax.get(requestUrls.articles.getPaged, {
        params: {
          filter: `a.objectId=="${this.projectData.id}"`,
          maxResultCount: 100,
          skipCount: 0
        }
      })
      this.inviteArticles = []
      this.correctArticles = []
      this.biddingArticles = []
      this.surveyArticles = []
      if (rep.data.success) {
        rep.data.result.items.forEach(item => {
          // 招标
          if (item.ext2 === '74166') {
            this.inviteArticles.push(item)
          }
          // 更正
          if (item.ext2 === '74169') {
            this.correctArticles.push(item)
          }
          // 结果
          if (item.ext2 === '74168') {
            this.biddingArticles.push(item)
          }
          // 调研
          if (item.ext2 === '74170') {
            this.surveyArticles.push(item)
          }
        })
      }
    },
    backProjectList() {
      this.$emit('back')
    },
    expertFill() {
      this.expertFileUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B4e13%5D%5B5bb6%5D%5B62bd%5D%5B53d6%5D%5B786e%5D%5B8ba4%5D%5B8868%5D%2F%5B4e13%5D%5B5bb6%5D%5B62bd%5D%5B53d6%5D%5B786e%5D%5B8ba4%5D%5B8868%5D%5B586b%5D%5B5199%5D.cpt&op=write&npid=${this.projectData.id}`
      this.expertFileVisible = true
    },
    expertShow() {
      this.expertFileUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B4e13%5D%5B5bb6%5D%5B62bd%5D%5B53d6%5D%5B786e%5D%5B8ba4%5D%5B8868%5D%2F%5B4e13%5D%5B5bb6%5D%5B62bd%5D%5B53d6%5D%5B786e%5D%5B8ba4%5D%5B8868%5D.cpt&npid=${this.projectData.id}`
      this.expertFileVisible = true
    }
  },
  watch: {
    projectData(val) {
      if (val) {
        this.getArtilces()
      }
    }
  }
}
</script>

<style lang="less">
.expert-modal {
  .ivu-modal {
    top: 20px;
  }
}
</style>
